/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki wynajmu') {
            document.title = 'Warunki wynajmu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI WYNAJMU</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Strona internetowa <a href="https://apart-house.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            www.apart-house.pl
                        </Button>
                    </a> przeznaczona jest do rezerwacji noclegów w apartamentach Apart House.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Właścicielem serwisu oraz prezentowanych na stronie apartamentów jest firma Apart-House Tylna 20 Katarzyna Antecka-Lubin, ul. Tylna 20, 65-413 Zielona Góra, NIP: 9291338747, REGON: 977907060, numer rachunku bankowego: 80 1020 5402 0000 0002 0499 3053 .</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji apartamentów można dokonywać on-line za pośrednictwem serwisu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem rezerwacji jest płatność on-line 100% ceny za wynajem w momencie rezerwacji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Możliwa jest płatność za rezerwację w obiekcie, przed zakwaterowaniem od poniedziałku do piątku po wcześniejszym umówieni się na konkretną godzinę.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności są <b>Przelewy24.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji można również dokonywać przez portal rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a> oraz <a href="https://www.airbnb.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            airbnb.pl
                        </Button>
                    </a></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności w przypadku rezerwacji przez serwis rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a> oraz <a href="https://www.airbnb.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            airbnb.pl
                        </Button>
                    </a> są te serwisy.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W obiekcie akceptujemy karty płatnicze.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zakwaterowanie w apartamentach odbywa się bezobsługowo na podstawie szczegółowych instrukcji oraz kodów dostępu wysyłanych w wiadomości sms i/lub e-mail na 1 lub 2 dni przed przyjazdem. Gość otrzymuje kod dostępu do drzwi głównych wejściowych oraz kod do drzwi apartamentu. Po wpisaniu kodu gość otworzy drzwi wejściowe, następnie uda się pod wskazany numer apartamentu i drugim kodem otworzy drzwi od apartamentu. Zakwaterowanie jest możliwe od godziny 15:00, wymeldowanie do godz. 11:00 ostatniego dnia pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na jeden lub więcej dni przed przyjazdem, Gość otrzyma pełny zwrot wpłaconych środków pomniejszonych o prowizję operatora płatności. Zwrot będzie wykonany w ciągu maksymalnie 7 dni roboczych na wskazany rachunek bankowy. W przypadku anulowania na mniej niż 1 dni przed przyjazdem, rezerwacja jest bezzwrotna. Ewentualny zwrot w takim przypadku jest rozpatrywany indywidualnie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie reklamacje powinny być zgłaszane pisemnie poprzez formularz kontaktowy na stronie <a href="https://apart-house.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            apart-house.pl
                        </Button>
                    </a> lub mailowo na adres <a href={`mailto:${'biuro@apart-house.pl'}`} target='_blank' className={`${classes.email}`}>{'biuro@apart-house.pl'}</a>. Czas odpowiedzi na reklamację wynosi do 7 dni roboczych.</Typography></li>
                </ol>
                
            
                {/* <br /><Typography align="right" gutterBottom>Dyrektor PPUH Hayduk</Typography>
                <Typography align="right" gutterBottom><b>Koralewska Monika</b></Typography> */}
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
